import { fireLinkTag } from './tagManager';

export const gwpPromotionClick = () => {
  fireLinkTag({
    event_name: 'pdp why to buy:gwp',
    link_name: 'pdp why to buy:gwp',
  });
};

export const otherPromotionClick = () => {
  fireLinkTag({
    event_name: 'pdp why to buy:non-loyalty non-gwp',
    link_name: 'pdp why to buy:non-loyalty non-gwp',
  });
};

export const loyaltyPromotionClick = () => {
  fireLinkTag({
    event_name: 'pdp why to buy:loyalty non-gwp',
    link_name: 'pdp why to buy:loyalty non-gwp',
  });
};

export const klarnaDetailsClicked = () => {
  fireLinkTag({
    event_name: 'pdp why to buy:klarna icon',
    link_name: 'pdp why to buy:klarna icon',
  });
};

export const ccfpDetailsClicked = () => {
  fireLinkTag({
    event_name: 'pdp why to buy:ccfp info',
    link_name: 'pdp why to buy:ccfp info',
  });
};

export const ppcDetailsClicked = () => {
  fireLinkTag({
    event_name: 'pdp why to buy:points calculator',
    link_name: 'pdp why to buy:points calculator',
  });
};

export const joinStarRewardsArrowClicked = () => {
  fireLinkTag({
    event_name: 'pdp why to buy:star rewards chevron',
    link_name: 'pdp why to buy:star rewards chevron',
  });
};

export const joinStarRewardsExclusionsClicked = () => {
  fireLinkTag({
    event_name: 'pdp why to buy:star rewards exclusions',
    link_name: 'pdp why to buy:star rewards exclusions',
  });
};

export const freeShippingDetailsClicked = () => {
  fireLinkTag({
    event_name: 'pdp why to buy:free shipping',
    link_name: 'pdp why to buy:free shipping',
  });
};
